import { createConfig } from '@privy-io/wagmi';
import { http } from 'wagmi';
import { arbitrum, base, mainnet, optimism, polygon } from 'wagmi/chains';

import { POLYGON_RPC_URL } from '@/utils/approvals.utils';

export const polymarketSupportedChains = [polygon, mainnet, base, arbitrum, optimism] as const;

export const wagmiConfig = createConfig({
  chains: polymarketSupportedChains,
  transports: {
    // Use the same reliable Polygon RPC the rest of the app uses.
    // Public fallback http() RPCs are rate-limited and cause NaN balance reads.
    [polygon.id]: http(POLYGON_RPC_URL),
    [mainnet.id]: http(),
    [base.id]: http(),
    [arbitrum.id]: http(),
    [optimism.id]: http(),
  },
});
